






















































import { Vue, Component } from "vue-property-decorator";
import CheckoutForm from "@/components/checkout/CheckoutForm.vue";
import OrderSummary from "@/components/checkout/OrderSummary.vue";
import { OrderType } from "@/models/order/helpers";
import { namespace } from "vuex-class";
import { StoreModule } from "@/store/types";
import { OrderActions, OrderGetters } from "@/store/modules/order/types";
import { LineItem, Order } from "@/models/order/order";
import ConfirmNewQuote from "@/components/elements/modal/ConfirmNewQuote.vue";
import { GlobalActions } from "@/store/modules/global/types";
@Component({
  components: {
    CheckoutForm,
    OrderSummary,
    ConfirmNewQuote,
  },
})
export default class Submitted extends Vue {
  @(namespace(StoreModule.Order).Action(OrderActions.ClearOrder))
  resetOrder!: () => Promise<void>;
  @(namespace(StoreModule.Order).Getter(OrderGetters.GetOrderItems))
  items!: LineItem[];
  @(namespace(StoreModule.Order).Getter(OrderGetters.GetOrder))
  order!: Order;
  @(namespace(StoreModule.Global).Action(GlobalActions.AddMultiplier))
  addMultiplier!: (value: number) => Promise<void>;
  protected orderType = OrderType;
  protected showModal = false;
  protected uniqueEmails: string[] = [];

  created(): void {
    if (this.order.items?.length === 0) {
      this.$router.replace("/");
    } else {
      const orderEmails: string[] = [this.order.contact_details.email];
      if (this.order.billing_details?.email) {
        orderEmails.push(this.order.billing_details.email);
      }
      if (this.order.shipping_details?.email) {
        orderEmails.push(this.order.shipping_details.email);
      }
      orderEmails.filter((email) => {
        if (!this.uniqueEmails.includes(email)) {
          this.uniqueEmails.push(email);
        }
      });
    }
  }

  async mounted(): Promise<void> {
    if (this.$route.query.type === OrderType.Order) {
      await this.resetOrder();
    }
  }

  get quote(): boolean {
    let type = false;
    if (this.$route.query.type === OrderType.Quote) {
      type = true;
    }
    return type;
  }

  protected hasPunctuation(index: number): boolean {
    const emailsLength = this.uniqueEmails.length;
    let result = false;
    if (emailsLength > 1 && emailsLength - 1 !== index) {
      result = true;
    }
    return result;
  }

  protected isNextToLastEmail(index: number): boolean {
    const emailsLength = this.uniqueEmails.length;
    let result = false;
    if (emailsLength > 1 && emailsLength - 2 === index) {
      result = true;
    }
    return result;
  }

  protected toggleNewQuoteModal(): void {
    if (this.items.length > 0) {
      // only toggling warning modal if there is an item associated with the order
      this.showModal = true;
    } else {
      this.clearOrder();
    }
  }

  protected close(): void {
    this.showModal = false;
  }

  protected async clearOrder(): Promise<void> {
    this.close();
    await this.resetOrder();
    await this.addMultiplier(1);
    if (this.$route.path !== "/collections/umbrella") {
      this.$router.push("/collections/umbrella");
    }
  }
}
